/* src/app/admin-dashboard/delivery/guide-dialog/guide-dialog.component.css */
.gd-content {
  max-width: 640px;
}
.gd-note {
  margin: 0 0 12px;
  color: #555;
  font-size: 13px;
}
.gd-empty {
  padding: 16px;
  text-align: center;
  color: #888;
  font-size: 13px;
}
.gd-error {
  color: #c0392b;
}
.gd-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.gd-field {
  flex: 1 1 260px;
}
.gd-field-sm {
  flex: 0 0 160px;
}
.gd-full {
  width: 100%;
}
.gd-photos-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
}
.gd-upload {
  color: #2f6fd0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px dashed #c9dcf7;
  border-radius: 8px;
  padding: 6px 12px;
  -webkit-user-select: none;
  user-select: none;
}
.gd-upload-busy {
  opacity: .5;
}
.gd-photos {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.gd-photo {
  width: 180px;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 6px;
  background: #fbfcfd;
}
.gd-photo img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
}
.gd-caption {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  padding: 4px 2px;
  color: #444;
  box-sizing: border-box;
}
.gd-caption::placeholder {
  color: #bbb;
}
.gd-photo-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gd-attribution {
  font-size: 11px;
  color: #888;
}
.gd-driver {
  color: #8a6417;
  font-weight: 600;
}
.gd-pins-head {
  display: flex;
  gap: 8px;
  margin: 4px 0 6px;
}
.gd-pin-tab {
  flex: 1;
  text-align: left;
  cursor: pointer;
  border: 1px solid #d6dbe1;
  border-radius: 8px;
  background: #fff;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #444;
}
.gd-pin-tab.on {
  border-width: 2px;
  padding: 7px 11px;
}
.gd-pin-parking.on {
  border-color: #1d6ef2;
  color: #1d6ef2;
}
.gd-pin-entrance.on {
  border-color: #ffa834;
  color: #b16a00;
}
.gd-pin-coord {
  display: block;
  font-weight: 400;
  font-size: 11px;
  color: #888;
  margin-top: 2px;
}
.gd-pin-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 20px;
  margin-bottom: 4px;
  font-size: 12px;
  color: #8a6417;
}
.gd-clear {
  border: none;
  background: none;
  color: #c0392b;
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
  padding: 2px 4px;
}
.gd-map {
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e3e6ea;
}
.gd-map-hint {
  margin: 6px 0 12px;
  font-size: 12px;
  color: #777;
}
.gd-history {
  margin: 0 0 14px;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 6px 12px;
  background: #fbfcfd;
}
.gd-history summary {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  padding: 4px 0;
}
.gd-edit {
  padding: 8px 0;
  border-top: 1px solid #eee;
  font-size: 13px;
}
.gd-edit:first-of-type {
  border-top: none;
}
.gd-edit-head {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gd-edit-when {
  color: #888;
}
.gd-revert {
  margin-left: auto;
}
.gd-edit-change {
  margin-top: 2px;
  word-break: break-word;
}
.gd-old {
  color: #999;
  text-decoration: line-through;
}
.gd-map-wrap {
  position: relative;
}
.gd-base {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 500;
  padding: 7px 12px;
  border-radius: 8px;
  border: 1px solid #d5d9de;
  background: rgba(255, 255, 255, .94);
  color: #333;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
/*# sourceMappingURL=guide-dialog.component.css.map */
